import TargetSvg from '~/assets/structure-icons/target.svg?react';

export default function TargetIcon({
    color,
    size = 12,
}: {
    color: string;
    size?: number;
}) {
    return (
        <TargetSvg
            width={size}
            height={size}
            style={{
                color,
                flexShrink: 0,
                display: 'block',
            }}
        />
    );
}
